/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".tablist-container[_ngcontent-%COMP%]{height:0}.nav-item[_ngcontent-%COMP%]{margin-top:-2.6rem;margin-bottom:2.6rem}"];
export { styles as styles };
//# sourceMappingURL=tabset-collapse.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/footer/tabset-collapse/tabset-collapse.component.scss.shim.ngstyle.js
// module id = 1450
// module chunks = 27 28 29